import { ReactElement, useCallback, useState } from 'react';
import MainLogo from './responsiveLogo';
import MenuButton from './menu';
import { FlexContainer, FlexItemGrow, Link } from './styles';
import useLogout from '../session/useLogout';
import { Modal } from 'react-bootstrap';
import RefreshOTPModal from '../refreshOTP/refreshOTPModal';
import Button from '@designSystem/buttons/index';
import { ExportIcon } from '@root/src/assets/images';
import useOrdersFilters from '@app/healthcheck/filterBar/useOrdersFilters';
import useWindowWidth from '@app/common/useWindowWidth';
import generateLinkForDownloadCSVFile from '../filterBar/downloadCSVFile';
import useStats from '@app/healthcheck/filterBar/useStats';

type NavbarComponentI = {
  handleLogout: () => void;
  showOTPModal: boolean;
  setShowOTPModal: (value: boolean) => void;
};

export const HeaderComponent = ({
  handleLogout,
  showOTPModal,
  setShowOTPModal,
}: NavbarComponentI): ReactElement => {
  const { filters } = useOrdersFilters();
  const { stats } = useStats();
  const { isMobileView } = useWindowWidth();

  const handleShowOTPModal = () => {
    setShowOTPModal(true);
  };
  return (
    <>
      <Modal show={showOTPModal}>
        <RefreshOTPModal handleClose={() => setShowOTPModal(false)} />
      </Modal>
      <FlexContainer data-testid="healthcheck-dashboard-navbar">
        <FlexItemGrow>
          <MainLogo />
        </FlexItemGrow>
        {isMobileView && (
          <Link
            disabled={!stats[filters.ordersState]}
            href={generateLinkForDownloadCSVFile(filters)}
          >
            <Button
              disabled={!stats[filters.ordersState]}
              type="secondary"
              icon={<ExportIcon />}
            />
          </Link>
        )}
        <MenuButton
          handleLogout={handleLogout}
          refreshOTP={handleShowOTPModal}
        />
      </FlexContainer>
    </>
  );
};

const Header = (): ReactElement => {
  const [showOTPModal, setShowOTPModal] = useState(false);
  const logout = useLogout();
  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  return (
    <HeaderComponent
      handleLogout={handleLogout}
      showOTPModal={showOTPModal}
      setShowOTPModal={setShowOTPModal}
    />
  );
};

export default Header;
